let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gqxrq")).then(() => parcelRequire('iGvW0'));